var map = {
	"./android-dev.png": 3235,
	"./bootstrap.svg": 8252,
	"./csharp.svg": 1975,
	"./css.png": 9357,
	"./html.png": 9437,
	"./java.png": 1574,
	"./jquery.png": 6588,
	"./js.png": 9599,
	"./laravel.png": 3955,
	"./mysql.png": 8065,
	"./octoberCMS.png": 4441,
	"./photoshop.png": 4404,
	"./php.png": 7948,
	"./python.png": 1096,
	"./react-native.png": 4045,
	"./react.webp": 2865,
	"./springboot.png": 9901,
	"./swiftui.png": 1991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 980;